import { COMMON_COMPONENTS } from '../AEM/constants';
import { ROUTES } from '../constants/routes';
import { getStateCodeSpecificUrlUsingProcessEnv } from '../helpers/navigationHelper';
import { AUTOMATIC_PAYMENTS_SETUP_CONSTANTS } from '../constants/automaticPaymentsSetupConstants';  

export const PROCESS_ENV_URLS = getStateCodeSpecificUrlUsingProcessEnv();

export const useMock = process.env.REACT_APP_USE_MOCK === 'true';

const baseRoutes = {
  member: '/v1/route/member',
  billing: '/v1/route/billing',
  payment: '/v1/route/payment',
  communication: '/v1/route/communication',
  maintenance: '/v1/route/common',
  wallet: '/v1/route/wallet',
  history: '/v1/route/history',
  govtPayment: '/v1/route/govt-payment',
  govtWallet: '/v1/route/govt-wallet',
};

const BASE_ROUTES_FOR_ACTIVE = {
  member: `/member${baseRoutes.member}/active`,
  billing: `/member${baseRoutes.billing}/active`,
  payment: `/member${baseRoutes.payment}/active`,
  wallet: `/member${baseRoutes.wallet}/active`,
  history: `/member${baseRoutes.history}/active`,
};

const BASE_ROUTES_FOR_CA = {
  member: `/member${baseRoutes.member}/active`,
  billing: `/member${baseRoutes.billing}/active`,
  payment: `/member${baseRoutes.payment}/active`,
  wallet: `/member${baseRoutes.wallet}/active`,
  history: `/member${baseRoutes.history}/active`,
};

const BASE_ROUTES_FOR_GOVERNMENT_ACTIVE = {
  member: `/member${baseRoutes.govtPayment}/active`,
  payment: `/member${baseRoutes.payment}/active`,
  wallet: `/member${baseRoutes.govtWallet}/active`,
};

const BASE_ROUTES_FOR_BINDER = '/v1/route/binder-pay';
const BASE_ROUTES_FOR_BROKER = '/v1/route/broker';
export const EXCLUDED_SOURCE_SYSTEMS = ['RDE', 'EPR'];

export const API_ROUTES_FOR_BINDER = {
  member: {
    initiatePayNow: `/binder/paynow`,
    binderPayNowLogin: `${BASE_ROUTES_FOR_BINDER}/binderPayNowLogin`,
    binderPayLaterLogin: `${BASE_ROUTES_FOR_BINDER}/validate-applicant`,
  },
  payment: {
    submitPayment: `${BASE_ROUTES_FOR_BINDER}/submit-payment`,
    deleteScheduledOneTimePayment: `${BASE_ROUTES_FOR_BINDER}/delete-schedule-onetime-payment`,
    paymentMethod: `${BASE_ROUTES_FOR_BINDER}/paymentMethod`,
    getScheduledOneTimePayment: `${BASE_ROUTES_FOR_BINDER}/get-schedule-onetime-payment`,
    schedulePayment: `${BASE_ROUTES_FOR_BINDER}/schedule-onetime-payment`,
    immediatePayment: `${BASE_ROUTES_FOR_BINDER}/pay-later-immediate-payment`,
    updateScheduledOneTimePayment: `${BASE_ROUTES_FOR_BINDER}/update-schedule-onetime-payment`,
  },
  session: {
    getSessionToken: `${BASE_ROUTES_FOR_BINDER}/sessionToken`,
  },
  billing: {
    getBillInfo: `${BASE_ROUTES_FOR_BINDER}/get-bill-info`,
  },
  wallet: {
    viewFilteredWallet: `${BASE_ROUTES_FOR_BINDER}/get-filtered-wallet`,
    getWallets: `${BASE_ROUTES_FOR_BINDER}/viewWallet`,
  },
  autopayment: {
    getAutopay: `${BASE_ROUTES_FOR_BINDER}/get-autopayment`,
    manageAutopay: `${BASE_ROUTES_FOR_BINDER}/pay-later-manage-autopay-setting`,
    createAutoPay: `${BASE_ROUTES_FOR_BINDER}/pay-later-auto-payment`,
  },
};

export const API_ROUTES_FOR_ACTIVE_MEMBER = {
  member: {
    validateMember: `${BASE_ROUTES_FOR_ACTIVE.member}/validateMember`,
    declineConversion: `${BASE_ROUTES_FOR_ACTIVE.member}/declineConversion`,
    getEmail: `${BASE_ROUTES_FOR_ACTIVE.member}/get-email-address`,
    autopayReminder: `${BASE_ROUTES_FOR_ACTIVE.member}/update-autopay-reminder`,
  },
  billing: {
    getPaymentBills: `${BASE_ROUTES_FOR_ACTIVE.billing}/getMemberPaymentInformation`,
    getBillDocument: `${BASE_ROUTES_FOR_ACTIVE.billing}/bill-document-content`,
    paymentManagement: `${BASE_ROUTES_FOR_ACTIVE.billing}/payment-management`,
  },
  payment: {
    submitImmeditatePayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/immediatePayment`,
    paymentMethod: `${BASE_ROUTES_FOR_ACTIVE.payment}/paymentMethod`,
    scheduledOneTimePayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/schedule-onetime-payment`,
    updateScheduledOneTimePayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/update-schedule-onetime-payment`,
    getScheduledOneTimePayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/get-schedule-onetime-payment`,
    deleteScheduledOneTimePayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/delete-schedule-onetime-payment`,
    getRecentPayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/paymentTracker`,
  },
  session: {
    getSessionToken: `${BASE_ROUTES_FOR_ACTIVE.payment}/sessionToken`,
  },
  wallet: {
    getWallets: `${BASE_ROUTES_FOR_ACTIVE.wallet}/viewWallet`,
    addWallet: `${BASE_ROUTES_FOR_ACTIVE.wallet}/addWallet`,
    updateWallet: `${BASE_ROUTES_FOR_ACTIVE.wallet}/updateWallet`,
    deleteWallet: `${BASE_ROUTES_FOR_ACTIVE.wallet}/deleteWallet`,
    viewFilteredWallet: `${BASE_ROUTES_FOR_ACTIVE.wallet}/get-filtered-wallet`,
  },
  autoPay: {
    autoPayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/auto-payment`,
    getAutoPayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/get-auto-payment`,
    deleteAutoPayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/delete-auto-payment`,
    updateAutoPayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/update-auto-payment`,
  },
  history: {
    getPaymentHistory: `${BASE_ROUTES_FOR_ACTIVE.history}/payment-history`,
    getBillingHistory: `${BASE_ROUTES_FOR_ACTIVE.history}/billing-history`,
  },
};
// todo - update active routes
export const API_ROUTES_FOR_CA_GOVT = {
  member: {
    validateMember: `${BASE_ROUTES_FOR_CA.member}/validateMember`,
  },
  billing: {
    getGovernmentMemberPaymentBills: `${BASE_ROUTES_FOR_ACTIVE.billing}/getGpdPaymentInformation`,
  },
  payment: {
    paymentMethod: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.payment}/paymentMethod`,
    submitGovernmentImmeditatePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/immediatePayment`,
    scheduledOneTimePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/schedule-onetime-payment`,
    updateScheduledOneTimePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/update-schedule-onetime-payment`,
    getScheduledPaymentIndicator: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/get-schedule-payment-indicator`,
    deleteScheduledOneTimePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/delete-schedule-onetime-payment`,
  },
  session: {
    getSessionToken: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/session-token`,
  },
  autoPay: {
    getAutoPayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/get-auto-payment`,
  },
  wallet: {
    getWallets: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/viewWallet`,
    addWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/addWallet`,
    updateWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/updateWallet`,
    deleteWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/deleteWallet`,
    viewFilteredWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/get-filtered-wallet`,
  },
  history: {
    getPaymentHistory: `${BASE_ROUTES_FOR_ACTIVE.history}/payment-history`,
    getBillingHistory: `${BASE_ROUTES_FOR_ACTIVE.history}/billing-history`,
  },
};
export const API_ROUTES_FOR_CA = {
  member: {
    validateMember: `${BASE_ROUTES_FOR_CA.member}/validateMember`,
  },
  billing: {
    getPaymentBills: `${BASE_ROUTES_FOR_CA.billing}/getMemberPaymentInformation/`,
    getBillDocument: `${BASE_ROUTES_FOR_CA.billing}/bill-document-content`,
  },
  payment: {
    submitImmeditatePayment: `${BASE_ROUTES_FOR_CA.payment}/immediatePayment`,
    paymentMethod: `${BASE_ROUTES_FOR_CA.payment}/paymentMethod`,
    scheduledOneTimePayment: `${BASE_ROUTES_FOR_CA.payment}/schedule-onetime-payment`,
    updateScheduledOneTimePayment: `${BASE_ROUTES_FOR_CA.payment}/update-schedule-onetime-payment`,
    getScheduledOneTimePayment: `${BASE_ROUTES_FOR_CA.payment}/get-schedule-onetime-payment`,
    deleteScheduledOneTimePayment: `${BASE_ROUTES_FOR_CA.payment}/delete-schedule-onetime-payment`,
    getRecentPayment: `${BASE_ROUTES_FOR_ACTIVE.payment}/paymentTracker`,
  },
  session: {
    getSessionToken: `${BASE_ROUTES_FOR_CA.payment}/sessionToken`,
  },
  wallet: {
    getWallets: `${BASE_ROUTES_FOR_CA.wallet}/viewWallet`,
    addWallet: `${BASE_ROUTES_FOR_CA.wallet}/addWallet`,
    updateWallet: `${BASE_ROUTES_FOR_CA.wallet}/updateWallet`,
    deleteWallet: `${BASE_ROUTES_FOR_CA.wallet}/deleteWallet`,
    viewFilteredWallet: `${BASE_ROUTES_FOR_CA.wallet}/get-filtered-wallet`,
  },
  autoPay: {
    autoPayment: `${BASE_ROUTES_FOR_CA.payment}/auto-payment`,
    getAutoPayment: `${BASE_ROUTES_FOR_CA.payment}/get-auto-payment`,
    deleteAutoPayment: `${BASE_ROUTES_FOR_CA.payment}/delete-auto-payment`,
  },
  history: {
    getPaymentHistory: `${BASE_ROUTES_FOR_CA.history}/payment-history`,
    getBillingHistory: `${BASE_ROUTES_FOR_CA.history}/billing-history`,
  },
};

export const API_ROUTES = {
  member: {
    validateMember: `${baseRoutes.member}/validateMember`,
  },
  billing: {
    getPaymentBills: `${baseRoutes.billing}/getMemberPaymentInformation`,
  },
  payment: {
    getToken: `${baseRoutes.payment}/authToken`,
    submitImmeditatePayment: `${baseRoutes.payment}/immediatePayment`,
    paymentMethod: `${baseRoutes.payment}/paymentMethod`,
  },
  session: {
    getSessionToken: `${baseRoutes.payment}/sessionToken`,
  },
  communication: {
    sendPaymentDetailsEmailConfirmation: `${baseRoutes.communication}/sendConfirmationEmail`,
  },
  maintenance: {
    scheduleMaintenance: `${baseRoutes.maintenance}/schedule-maintenance`,
    caId: `${baseRoutes.maintenance}/get-ca-userid`,
  },
};

export const API_ROUTES_FOR_BROKER = {
  member: {
    validateBrokerPortalMember: `${BASE_ROUTES_FOR_BROKER}/validate-broker`,
    getEmail: `${BASE_ROUTES_FOR_BROKER}/get-email-address`,
  },
  autoPay: {
    getAutoPayment: `${BASE_ROUTES_FOR_BROKER}/get-auto-payment`,
    autoPayment: `${BASE_ROUTES_FOR_BROKER}/auto-payment`,
    updateAutoPayment: `${BASE_ROUTES_FOR_BROKER}/update-auto-payment`,
  },
  billing: {
    getPaymentBills: `${baseRoutes.billing}/getMemberPaymentInformation`,
  },
  payment: {
    getToken: `${baseRoutes.payment}/authToken`,
    submitImmeditatePayment: `${baseRoutes.payment}/immediatePayment`,
    paymentMethod: `${baseRoutes.payment}/paymentMethod`,
  },
  session: {
    getSessionToken: `${baseRoutes.payment}/sessionToken`,
  },
  communication: {
    sendPaymentDetailsEmailConfirmation: `${baseRoutes.communication}/sendConfirmationEmail`,
  },
  maintenance: {
    scheduleMaintenance: `${baseRoutes.maintenance}/schedule-maintenance`,
  },
};

export const API_ROUTES_FOR_GOVT_GUEST = {
  ...API_ROUTES,
  member: {
    ...API_ROUTES.member,
    getEmail: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/get-email-address`,
  },
  billing: {
    getGovernmentMemberPaymentBills: `${baseRoutes.billing}/getGpdPaymentInformation`,
  },
  payment: {
    submitGovernmentImmeditatePayment: `${baseRoutes.govtPayment}/immediatePayment`,
    paymentMethod: `${baseRoutes.payment}/paymentMethod`,
  },
  session: {
    getSessionToken: `${baseRoutes.govtPayment}/session-token`,
  },
};

export const API_ROUTES_FOR_GOVT_ACTIVE = {
  member: {
    validateMember: `${baseRoutes.member}/validateMember`,
  },
  billing: {
    getGovernmentMemberPaymentBills: `${BASE_ROUTES_FOR_ACTIVE.billing}/getGpdPaymentInformation`,
  },
  autoPay: {
    getAutoPayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/get-auto-payment`,
  },
  payment: {
    paymentMethod: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.payment}/paymentMethod`,
    submitGovernmentImmeditatePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/immediatePayment`,
    scheduledOneTimePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/schedule-onetime-payment`,
    updateScheduledOneTimePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/update-schedule-onetime-payment`,
    getScheduledPaymentIndicator: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/get-schedule-payment-indicator`,
    deleteScheduledOneTimePayment: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/delete-schedule-onetime-payment`,
  },
  session: {
    getSessionToken: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.member}/session-token`,
  },
  wallet: {
    getWallets: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/viewWallet`,
    addWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/addWallet`,
    updateWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/updateWallet`,
    deleteWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/deleteWallet`,
    // viewFilteredWallet: `${BASE_ROUTES_FOR_GOVERNMENT_ACTIVE.wallet}/get-filtered-wallet`,
  },
  history: {
    getPaymentHistory: `${BASE_ROUTES_FOR_ACTIVE.history}/payment-history`,
    getBillingHistory: `${BASE_ROUTES_FOR_ACTIVE.history}/billing-history`,
  },
};

interface IPaymentMethodProps {
  iframeUrl: string;
  iframeHeight: string;
  afterSubmitIframeHeight: string;
}

interface IPaymentMethodIframeProps {
  [key: string]: IPaymentMethodProps;
}

export const PAYMENT_METHOD_IFRAME_DETAILS: IPaymentMethodIframeProps = {
  'BANK ACCOUNT': {
    iframeUrl: `${PROCESS_ENV_URLS.iframeUrlBank}?languageIndicator=en-US&billerShortName=HCSC`,
    iframeHeight: '540px',
    afterSubmitIframeHeight: '655px',
  },
  CARD: {
    iframeUrl: `${PROCESS_ENV_URLS.iframeUrlCard}?languageIndicator=en-US&billerShortName=HCSC`,
    iframeHeight: '415px',
    afterSubmitIframeHeight: '505px',
  },
};

const EXCLUSIVE_AEM_ERRORCODE_ROUTES: any = {
  [`${ROUTES.aemRoutes.baseRoute}${ROUTES.aemRoutes.commonRoute}?state=IL&language=EN&componentName=${COMMON_COMPONENTS.HOURS_OF_OPERATION}`]:
    ['**'],
  [`${ROUTES.aemRoutes.baseRoute}${ROUTES.aemRoutes.commonRoute}?state=OK&language=EN&componentName=${COMMON_COMPONENTS.HOURS_OF_OPERATION}`]:
    ['**'],
  [`${ROUTES.aemRoutes.baseRoute}${ROUTES.aemRoutes.commonRoute}?state=MT&language=EN&componentName=${COMMON_COMPONENTS.HOURS_OF_OPERATION}`]:
    ['**'],
  [`${ROUTES.aemRoutes.baseRoute}${ROUTES.aemRoutes.commonRoute}?state=TX&language=EN&componentName=${COMMON_COMPONENTS.HOURS_OF_OPERATION}`]:
    ['**'],
  [`${ROUTES.aemRoutes.baseRoute}${ROUTES.aemRoutes.commonRoute}?state=NM&language=EN&componentName=${COMMON_COMPONENTS.HOURS_OF_OPERATION}`]:
    ['**'],
};
export const EXCLUSIVE_ERRORCODE_ROUTES: any = {
  ...EXCLUSIVE_AEM_ERRORCODE_ROUTES,
  [API_ROUTES.member.validateMember]: [404, 503],
  [`${ROUTES.aemRoutes.baseRoute}${ROUTES.aemRoutes.userBasedAlert}`]: ['**'],
  [`${ROUTES.aemRoutes.baseRoute}${ROUTES.aemRoutes.menuItemsConfig}`]: ['**'],
  //exclude immediatePayment & sessionToken apis for all error codes
  [API_ROUTES.payment.submitImmeditatePayment]: ['**'],
  [API_ROUTES.session.getSessionToken]: ['**'],
  [API_ROUTES.communication.sendPaymentDetailsEmailConfirmation]: [404],
  [API_ROUTES_FOR_ACTIVE_MEMBER.wallet.getWallets]: [404],
  [API_ROUTES_FOR_ACTIVE_MEMBER.wallet.viewFilteredWallet]: [404],
  [API_ROUTES_FOR_ACTIVE_MEMBER.wallet.updateWallet]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.wallet.addWallet]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.wallet.deleteWallet]: [400],
  [API_ROUTES_FOR_ACTIVE_MEMBER.member.validateMember]: [404, 503],
  [API_ROUTES_FOR_ACTIVE_MEMBER.payment.submitImmeditatePayment]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.payment.scheduledOneTimePayment]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.session.getSessionToken]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.payment.getScheduledOneTimePayment]: [404],
  [API_ROUTES_FOR_ACTIVE_MEMBER.member.getEmail]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.payment.getRecentPayment]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.billing.paymentManagement]: ['**'],
  [API_ROUTES_FOR_BINDER.member.binderPayLaterLogin]: [404],
  [API_ROUTES_FOR_BINDER.wallet.viewFilteredWallet]: [404],
  [API_ROUTES_FOR_BINDER.payment.getScheduledOneTimePayment]: [404],
  [API_ROUTES_FOR_BINDER.session.getSessionToken]: ['**'],
  [API_ROUTES_FOR_BINDER.wallet.getWallets]: [404],
  [API_ROUTES_FOR_BINDER.autopayment.createAutoPay]: [500],
  [API_ROUTES_FOR_BINDER.autopayment.manageAutopay]: ['**'],
  [API_ROUTES_FOR_BINDER.payment.immediatePayment]: ['**'],
  [API_ROUTES_FOR_BINDER.payment.schedulePayment]: ['**'],
  [API_ROUTES_FOR_BINDER.payment.updateScheduledOneTimePayment]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.billing.paymentManagement]: ['**'],
  [API_ROUTES_FOR_GOVT_GUEST.payment.submitGovernmentImmeditatePayment]: ['**'],
  [API_ROUTES_FOR_GOVT_GUEST.billing.getGovernmentMemberPaymentBills]: [404],
  [API_ROUTES_FOR_GOVT_GUEST.session.getSessionToken]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.session.getSessionToken]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.payment.getRecentPayment]: ['**'],
  [API_ROUTES_FOR_GOVT_ACTIVE.payment.submitGovernmentImmeditatePayment]: [
    '**',
  ],
  [API_ROUTES_FOR_GOVT_ACTIVE.billing.getGovernmentMemberPaymentBills]: [404],
  [API_ROUTES_FOR_GOVT_ACTIVE.autoPay.getAutoPayment]: [404, 500],
  [API_ROUTES_FOR_GOVT_ACTIVE.wallet.getWallets]: [404],
  [API_ROUTES_FOR_GOVT_ACTIVE.wallet.addWallet]: ['**'],
  [API_ROUTES_FOR_GOVT_ACTIVE.wallet.updateWallet]: ['**'],
  [API_ROUTES_FOR_GOVT_ACTIVE.session.getSessionToken]: ['**'],
  [API_ROUTES_FOR_GOVT_ACTIVE.wallet.deleteWallet]: [400],
  [API_ROUTES_FOR_GOVT_ACTIVE.payment.getScheduledPaymentIndicator]: ['**'],
  [API_ROUTES_FOR_GOVT_ACTIVE.payment.scheduledOneTimePayment]: ['**'],
  [API_ROUTES_FOR_CA_GOVT.payment.submitGovernmentImmeditatePayment]: ['**'],
  [API_ROUTES_FOR_CA_GOVT.billing.getGovernmentMemberPaymentBills]: [404],
  [API_ROUTES_FOR_CA_GOVT.autoPay.getAutoPayment]: [404, 500],
  [API_ROUTES_FOR_CA_GOVT.wallet.getWallets]: [404],
  [API_ROUTES_FOR_CA_GOVT.wallet.addWallet]: ['**'],
  [API_ROUTES_FOR_CA_GOVT.wallet.updateWallet]: ['**'],
  [API_ROUTES_FOR_CA_GOVT.session.getSessionToken]: ['**'],
  [API_ROUTES_FOR_CA_GOVT.wallet.deleteWallet]: [400],
  [API_ROUTES_FOR_CA_GOVT.payment.getScheduledPaymentIndicator]: ['**'],
  [API_ROUTES_FOR_CA_GOVT.payment.scheduledOneTimePayment]: ['**'],
  [API_ROUTES_FOR_ACTIVE_MEMBER.autoPay.autoPayment]: [400],
  [API_ROUTES_FOR_CA.autoPay.autoPayment]: [400],
  [API_ROUTES_FOR_GOVT_ACTIVE.payment.scheduledOneTimePayment]: ['**'],
  [API_ROUTES_FOR_BROKER.member.validateBrokerPortalMember]: [404, 503, 400],
  [API_ROUTES_FOR_BROKER.autoPay.getAutoPayment]: [404, 500],
  [API_ROUTES_FOR_BROKER.payment.submitImmeditatePayment]: ['**'],
  [API_ROUTES_FOR_BROKER.session.getSessionToken]: ['**'],
  [API_ROUTES_FOR_BROKER.communication.sendPaymentDetailsEmailConfirmation]: [
    404,
  ],

// AC6: on system/network failure, keep the member on the Automatic
  // Payments Setup form with an inline retry banner instead of redirecting
  // to the global technical-difficulty/error screen.
  [AUTOMATIC_PAYMENTS_SETUP_CONSTANTS.API.ENROLL_AUTOPAY]: ['**'],
};

export const EXCLUSIVE_LOADER_ROUTES: string[] = [
  API_ROUTES.payment.submitImmeditatePayment,
  API_ROUTES_FOR_ACTIVE_MEMBER.payment.scheduledOneTimePayment,
  API_ROUTES_FOR_ACTIVE_MEMBER.payment.submitImmeditatePayment,
  PROCESS_ENV_URLS.accessTokenUri,
  API_ROUTES_FOR_GOVT_GUEST.payment.submitGovernmentImmeditatePayment,
  API_ROUTES_FOR_GOVT_GUEST.billing.getGovernmentMemberPaymentBills,
  API_ROUTES_FOR_GOVT_ACTIVE.payment.submitGovernmentImmeditatePayment,
];
